import {useCallback, useEffect, useState} from 'react';

export const COOKIES_CONSENT_GROUPS = {
  TARGETING: 'C0004'
};

export function useCookiesConsent({targetingGroup}) {
  const [isConsentGiven, setIsConsentGiven] = useState(false);
  const [isCheckingConsent, setIsCheckingConsent] = useState(true);

  const checkConsentStatus = useCallback(() => {
    try {
      if (!window.OneTrust || !window.OneTrust.IsAlertBoxClosed()) {
        return null;
      }

      if (window.OnetrustActiveGroups) {
        return window.OnetrustActiveGroups.includes(targetingGroup);
      }

      return false;
    } catch (error) {
      return false;
    }
  }, [targetingGroup]);

  const updateConsentStatus = useCallback(() => {
    const consentStatus = checkConsentStatus();

    if (consentStatus !== null) {
      setIsConsentGiven(consentStatus);
      setIsCheckingConsent(false);
    }
  }, [checkConsentStatus]);

  useEffect(() => {
    const performInitialCheck = () => {
      if (window.OnetrustActiveGroups) {
        setIsConsentGiven(window.OnetrustActiveGroups.includes(targetingGroup));
        setIsCheckingConsent(false);
        return;
      }

      if (window.OneTrust) {
        updateConsentStatus();
      }
    };

    performInitialCheck();

    const fallbackTimeout = setTimeout(() => {
      if (isCheckingConsent) {
        setIsCheckingConsent(false);
        setIsConsentGiven(false);
      }
    }, 10000);

    const handleOneTrustLoaded = () => {
      updateConsentStatus();
    };

    const handleConsentChanged = () => {
      updateConsentStatus();
    };

    window.addEventListener('OneTrustLoaded', handleOneTrustLoaded);
    window.addEventListener('OptanonLoaded', handleOneTrustLoaded);
    window.addEventListener('OneTrustGroupsUpdated', handleConsentChanged);

    return () => {
      clearTimeout(fallbackTimeout);
      window.removeEventListener('OneTrustLoaded', handleOneTrustLoaded);
      window.removeEventListener('OptanonLoaded', handleOneTrustLoaded);
      window.removeEventListener('OneTrustGroupsUpdated', handleConsentChanged);
    };
  }, [updateConsentStatus, targetingGroup, isCheckingConsent]);

  return {
    isCheckingConsent,
    isConsentGiven
  };
}
